import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Select,
  Space,
  notification,
  Upload,
  Button,
  Input,
  Tag,
  Tooltip
} from "antd";
import {
  dineroDisabledMask,
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  round2Decimals,
  ModalItem,
  ButtonItem,
  InputItem,
  NotificacionPolizas,
  round6Decimals,
  DatePickerItem,
  SwitchItem,
  ErrorItem,
  SelectFacturasItem,
  SelectInsumosItem,
  calcularAjusteAutomaticoFactura
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import xmlToJson from "../../../../Components/xmlToJson";
import { DeleteOutlined, PlusOutlined, UploadOutlined, SearchOutlined, InfoCircleOutlined, CarOutlined, EnvironmentOutlined, PhoneFilled, UserOutlined, ToolOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import ModalDiagnosticoCuadre from "../../../../Components/ModalDiagnosticoCuadre";
import {
  leerCfdiParaDiagnostico,
  construirCapturadoDesdeTotales,
  diagnosticarCuadreFactura,
} from "../../../../Utils/diagnosticoCuadreFactura";
import GeneralFormLayout from "../../../../Components/GeneralFormLayout";
import InfoCard from "../../../../Components/InfoCard";
import decodeHTMLEntities from "../../../../Components/decodeHtmlEntities";
import { esUuidSat } from "../../../../Utils/uuidFactura";

const { Option } = Select;

moment.locale("es");


function calcularTotalesInsumo(insumoRow, proveedor) {
  const insumo = insumoRow.insumoCompleto;
  if (!insumo) return insumoRow;

  const precioUnitario = Number(insumoRow.precioUnitario || 0);
  const cantidad = insumoRow.cantidad;
  const descuento = insumoRow.descuento || 0;

  let totalImpuestosPrecioSinImpuestos = 0;
  for (const imp of insumo.impuestos) {
    let t = 0;
    if (imp.tasaCuota === 1) t = precioUnitario * (imp.monto / 100);
    else if (imp.tasaCuota === 2) t = (precioUnitario + totalImpuestosPrecioSinImpuestos) * (imp.monto / 100);
    else if (imp.tasaCuota === 3) t = imp.monto;
    else if (imp.tasaCuota === 4) t = cantidad ? (insumoRow.impuestos || 0) / cantidad : 0;
    // tasaCuota 5 = 0
    totalImpuestosPrecioSinImpuestos += t;
  }
  const precioUnitarioConImpuestos = round2Decimals(precioUnitario + totalImpuestosPrecioSinImpuestos);

  if (!((precioUnitario || precioUnitario === 0) && cantidad)) {
    return { ...insumoRow, precioUnitarioConImpuestos };
  }

  const subtotalBruto = round6Decimals(cantidad * precioUnitario);
  const totalDescuento = round6Decimals(subtotalBruto * (descuento / 100));
  const totalEntrada = round6Decimals(subtotalBruto - totalDescuento);

  let totalImpuestos = 0;
  const arrayImpuestos = insumo.impuestos.map((imp) => {
    let t = 0;
    if (imp.tasaCuota === 1) t = round6Decimals(totalEntrada * (imp.monto / 100));
    else if (imp.tasaCuota === 2) t = round6Decimals((totalEntrada + totalImpuestos) * (imp.monto / 100));
    else if (imp.tasaCuota === 3) t = round6Decimals(cantidad * imp.monto);
    else if (imp.tasaCuota === 4) t = round6Decimals(insumoRow.impuestos || 0);
    // tasaCuota 5 = 0
    totalImpuestos += t;
    return { descripcionFactura: imp.descripcionFactura, totalImpuestos: t };
  });

  const total = round2Decimals(totalEntrada + totalImpuestos);

  // Retenciones
  let totalRetenciones = 0;
  const arrayRetenciones = [];

  if (proveedor) {
    const procesarRetencion = (ret, condicion = true) => {
      if (!condicion) return;
      let t = 0;
      if (ret.tasaCuota === 1) t = round6Decimals(totalEntrada * (ret.monto / 100));
      else if (ret.tasaCuota === 2) t = round6Decimals((totalEntrada + totalRetenciones) * (ret.monto / 100));
      totalRetenciones += t;
      arrayRetenciones.push({ descripcionFactura: ret.descripcionFactura, totalRetenciones: t });
    };

    for (const ret of (proveedor.retenciones || [])) {
      procesarRetencion(ret);
    }
    for (const ret of (insumo.retenciones || [])) {
      const aplica =
        (ret.aplicaCompra === 1 && !proveedor.persona) ||
        (ret.aplicaCompra === 2 && proveedor.persona) ||
        ret.aplicaCompra === 3;
      procesarRetencion(ret, aplica);
    }
  }

  return {
    ...insumoRow,
    precioUnitarioConImpuestos,
    subtotal: totalEntrada,
    impuestos: totalImpuestos,
    arrayImpuestos,
    total,
    retenciones: totalRetenciones,
    arrayRetenciones,
  };
}


class AgregarNotaDeCredito extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProveedores: null,
    todasProveedores: [],
    objetoProyectos: null,
    todasProyectos: null,
    objetoMonedas: null,
    todasMonedas: null,
    impuestos: [],
    modalConfirmacion: false,
    valuesForm: null,
    empresaRfc: null,
    rendered: 0,
    ajusteMax: 0,
    facturaId: this.props?.location?.state?.facturaId,
    todasFacturas: [],
    tipoDeCambioFactura: 1,
    datosFactura: null,
    busquedaInsumo: "",
    insumoResaltado: null,
    uuidDuplicado: false,
    mensajeUuidDuplicado: undefined,
    xmlFile: null,
    xmltotales: null,
    // Desglose completo del CFDI (conceptos, traslados, retenciones, implocal) para el
    // diagnostico de cuadre. xmltotales solo guarda SubTotal y Total.
    xmlDiagnostico: null,
    modalDiagnosticoVisible: false,
    diagnostico: null,
    ajusteContexto: null,
  };
  async componentDidMount() {
    this.setState({ loading: true });
    await this.consultarTodo()
    if (this.props?.location?.state?.fileName) {
      this.leerXmlData(this.props.location.state)
    }
    this.setState({ loading: false });
  }

  promisedSetState = (newState) => new Promise(resolve => this.setState(newState, resolve));

  async consultarTodo() {

    const responseConfiguracion = axios
      .post(
        "empresas/selectConfiguracionGeneralParaFacturas",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )

    const responseProveedores = axios
      .post(
        "proveedores/selectProveedores",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )

    const responseProyectos = axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )

    const responseMonedas = axios
      .post(
        "monedas/selectMonedas",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )

    const responses = await Promise.all([
      responseConfiguracion,
      responseProveedores,
      responseProyectos,
      responseMonedas
    ])

    let newState = {}

    if (responses[0].data.status === 404) {
      message.error("Error no se encontro configuracion de esta empresa");
    } else {
      newState.empresaRfc = responses[0].data.rfc
      newState.ajusteMax = responses[0].data.ajusteMax
    }

    if (responses[1].data.status === 404) {
    } else {
      newState.todasProveedores = responses[1].data
      newState.objetoProveedores = responses[1].data.map((value) => {
        return (
          <Option value={value._id} key={value._id}>
            {value.stringBuscar}
          </Option>
        );
      })
    }

    if (responses[2].data.status === 404) {
    } else {
      newState.todasProyectos = responses[2].data
      newState.objetoProyectos = responses[2].data.map((value) => {
        return (
          <Option value={value._id} key={value._id}>
            {value.nombre}
          </Option>
        );
      })
    }

    if (responses[3].data.status === 404) {
    } else {
      newState.todasMonedas = responses[3].data
      newState.objetoMonedas = responses[3].data.map((value) => {
        return (
          <Option value={value._id} key={value._id}>
            {value.nombre + " - " + value.abreviacion}
          </Option>
        );
      })
    }

    await this.promisedSetState(newState)

    if (this.state.facturaId) {
      await axios
        .post(
          "notasDeCreditoCompra/datosFactura",
          { empresaId: this.props.empresaId, facturaId: this.state.facturaId },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          if (res.data.status === 404) {
            message.error("Error no se encontro informacion de la factura");
          } else {
            this.formRef.current.setFieldsValue({
              ...res.data,
              uuid: undefined,
              uuidRelacionado: res.data.uuid,
              fechaFactura: undefined,
              ajusteSubtotal: 0,
              insumos: [],
              tipoDeCambioCompra: res.data.tipoDeCambio
            });
          }
        });

    }



  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    if (this.state.uuidDuplicado) {
      return message.error(
        this.state.mensajeUuidDuplicado ||
        "No se puede registrar: la nota de crédito ya existe en el sistema"
      );
    }
    this.setState({ loading: true });
    let insumos = values.insumos;
    let total = 0;
    let subtotal = 0;
    let arrayImpuestos = [];
    let arrayRetenciones = [];
    let cuentasProveedor = 0;
    insumos.map((value) => {
      total += value.subtotal;
      subtotal += value.subtotal;
      value.arrayImpuestos.map((valueImpuestos) => {
        let index = arrayImpuestos.findIndex(
          (valueImpuestosAnterios) =>
            valueImpuestosAnterios.descripcionFactura ===
            valueImpuestos.descripcionFactura
        );
        if (index !== -1) {
          let newItem = {
            totalImpuestos:
              arrayImpuestos[index].totalImpuestos +
              valueImpuestos.totalImpuestos,
            descripcionFactura: valueImpuestos.descripcionFactura,
          };
          arrayImpuestos.splice(index, 1, newItem);
        } else {
          arrayImpuestos.push({
            totalImpuestos: valueImpuestos.totalImpuestos,
            descripcionFactura: valueImpuestos.descripcionFactura,
          });
        }
        return null;
      });
      if (value.arrayRetenciones) {
        value.arrayRetenciones.map((valueRetenciones) => {
          let index = arrayRetenciones.findIndex(
            (valueRetencionesAnterios) =>
              valueRetencionesAnterios.descripcionFactura ===
              valueRetenciones.descripcionFactura
          );
          cuentasProveedor += round2Decimals(valueRetenciones.totalRetenciones);
          if (index !== -1) {
            let newItem = {
              totalRetenciones:
                arrayRetenciones[index].totalRetenciones +
                valueRetenciones.totalRetenciones,
              descripcionFactura:
                valueRetenciones.descripcionFactura,
            };
            arrayRetenciones.splice(index, 1, newItem);
          } else {
            arrayRetenciones.push({
              totalRetenciones: valueRetenciones.totalRetenciones,
              descripcionFactura:
                valueRetenciones.descripcionFactura,
            });
          }
          return null;
        });
      }
      return null;
    });
    subtotal += values.ajusteSubtotal
    total += values.ajusteSubtotal
    arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
      let ajusteImpuesto = values['ajuste' + valueImpuesto.descripcionFactura] || 0
      total += round2Decimals(valueImpuesto.totalImpuestos + ajusteImpuesto)
      return {
        ...valueImpuesto,
        ajusteImpuesto,
        totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos + ajusteImpuesto),
      }
    })
    arrayRetenciones = arrayRetenciones.map(valueRetencion => {
      let ajusteRetencion = values['ajuste' + valueRetencion.descripcionFactura] || 0
      cuentasProveedor += ajusteRetencion
      return {
        ...valueRetencion,
        ajusteRetencion,
        totalRetenciones: (valueRetencion.totalRetenciones + ajusteRetencion),
      }
    })

    // let tipoDeCambioPago = values.tipoDeCambio
    // let subtotalPagarConEquivalencia = 0
    // let totalPagarConEquivalencia = 0
    // let totalPagarPagarConEquivalencia = 0

    // for (const valueFacturaRelacionada of values.facturasRelacionadas || []) {
    //   let tipoDeCambioCompra = valueFacturaRelacionada.tipoDeCambioCompra
    //   const equivalencia = tipoDeCambioCompra / tipoDeCambioPago
    //   subtotalPagarConEquivalencia += round2Decimals(valueFacturaRelacionada.subtotal * equivalencia)
    //   totalPagarConEquivalencia += round2Decimals(valueFacturaRelacionada.total * equivalencia)
    //   totalPagarPagarConEquivalencia += round2Decimals(valueFacturaRelacionada.totalPagar * equivalencia)
    // }

    // if (
    //   Math.abs(round2Decimals(subtotal) - round2Decimals(subtotalPagarConEquivalencia)) > 0.05 || 
    //   Math.abs(round2Decimals(total) - round2Decimals(totalPagarConEquivalencia)) > 0.05 || 
    //   Math.abs(round2Decimals((total - cuentasProveedor)) - round2Decimals(totalPagarPagarConEquivalencia)) > 0.05
    // ) {
    //   this.setState({ loading: false });
    //   return message.info('No se puede capturar un monto mayor a la factura')
    // }

    if (
      round2Decimals(
        round2Decimals(this.state?.xmltotales?.Total || 0) - round2Decimals(total - cuentasProveedor)
      ) !== 0 &&
      this.state.xmltotales &&
      !this.state.estadoCC &&
      !this.state.divisas
    ) {
      this.setState({ loading: false });
      return message.error(
        'El total de la factura no coincide con el total del XML. Usa el botón "¿Por qué no cuadra?" junto a los totales para ver el detalle.'
      );
    }

    axios
      .post(
        "notasDeCreditoCompra/agregarNotaDeCredito",
        {
          ...values,
          empresaId: this.props.empresaId,
          total: round2Decimals(total),
          subtotal: round2Decimals(subtotal),
          cuentasProveedor: round2Decimals(cuentasProveedor),
          totalPagar: round2Decimals(total - cuentasProveedor),
          arrayImpuestos,
          arrayRetenciones
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se ha registrado una nota de credito"
          );
          NotificacionPolizas(res.data.polizasId)
          this.atras();
        } else if (res.data.success === 1) {
          message.error(res.data.message);
        } else {
          message.error("Hubo un error y la factura no se registro");
        }
      });
  }
  async leerXml(e) {
    this.setState({ loading: true });

    if (e.file.type === "text/xml") {
      var reader = new FileReader();
      reader.onload = async (event) => {
        try {
          let insumosSinRegistrar = 0;
          let insumos = [];
          let fechaFactura;
          let uuid;
          let codigoFactura;
          let tipoDeCambio;
          let monedaId;
          let proveedorId;

          const hola = new xmlToJson().parseFromString(event.target.result);
          const comprobante = hola?.attributes;
          const emisor = hola.children.find((valueXml) => valueXml.name === "cfdi:Emisor")?.attributes;
          const complemento = hola.children.find((valueXml) => valueXml.name === "cfdi:Complemento");
          const timbre = complemento?.children?.find((valueXml) => valueXml.name === "tfd:TimbreFiscalDigital")?.attributes;
          const receptor = hola.children.find((valueXml) => valueXml.name === "cfdi:Receptor")?.attributes;
          const conceptos = hola.children.find((valueXml) => valueXml.name === "cfdi:Conceptos")?.children;
          const cfdisRelacionados = hola.children.find((valueXml) => valueXml.name === "cfdi:CfdiRelacionados")?.children;

          if (comprobante.TipoDeComprobante !== 'E') {
            this.setState({
              archivosXml: [{ ...e.file, name: e.file.name, status: "success" }],
              archivo: e.file,
              loading: false
            });
            return message.error("El xml no es una nota de credito");
          }

          if (receptor.Rfc?.toLowerCase() === this.state.empresaRfc?.toLowerCase()) {
            const proveedorEncontrado = this.state.todasProveedores?.find(
              (valueTodos) => valueTodos.rfc?.toLowerCase() === decodeHTMLEntities(emisor.Rfc ? emisor.Rfc : "").toLowerCase()
            );

            if (!proveedorEncontrado) {
              this.setState({ loading: false });
              notification.warning({ message: "El proveedor no esta registrado" });
              return this.props.history.push("/panel/leerXml", {
                fileName: e.file.name,
                fileData: JSON.stringify(hola),
                origin: "/panel/agregarNotaDeCredito",
                state: { facturaId: this.state.facturaId }
              });
            } else {
              proveedorId = proveedorEncontrado._id;
            }
          } else {
            this.setState({
              archivosXml: [{ ...e.file, name: e.file.name, status: "success" }],
              archivo: e.file,
              loading: false,
            });
            return message.error("El rfc del receptor no es igual al de la empresa");
          }

          const facturasRelacionadas = (cfdisRelacionados || []).map(valueRelacionado => {
            const attr = valueRelacionado.attributes;
            return {
              uuidRelacionado: attr.UUID,
              montoPago: cfdisRelacionados?.length === 1 ? comprobante.Total : undefined
            }
          });

          const conceptosData = conceptos.map((valueConcepto) => {
            const attr = valueConcepto.attributes;
            let totalImpuestos = 0;
            
            valueConcepto.children
              .find((valueTodos) => valueTodos.name === "cfdi:Impuestos")
              ?.children.find((valueTodos) => valueTodos.name === "cfdi:Traslados")
              ?.children.map((valueImpuesto) => {
                totalImpuestos += Number(valueImpuesto.attributes.Importe || 0);
                return null;
              });

            return {
              codigo: attr.NoIdentificacion,
              descripcion: attr.Descripcion,
              claveProdServ: attr.ClaveProdServ,
              claveUnidad: attr.ClaveUnidad,
              precioUnitario: Number(attr.ValorUnitario),
              cantidad: attr.Cantidad,
              unidad: attr.ClaveUnidad,
              descuento: attr.Descuento ? Math.round((attr.Descuento / attr.Importe) * 1000000) / 10000 : 0,
              impuestos: totalImpuestos,
            };
          });

          const res = await axios.post(
            "insumos/procesarXml",
            { empresaId: this.props.empresaId, proveedorId, conceptos: conceptosData },
            { headers: this.props.headersToken }
          );

          if (res.data.success === 2) {
            insumos = res.data.insumos;
            insumosSinRegistrar = res.data.insumosSinRegistrar;
          } else {
            message.error("Error al procesar los insumos del XML.");
            this.setState({ loading: false });
            return;
          }

          const pagosXML = {
            SubTotal: comprobante.SubTotal - (comprobante.Descuento || 0),
            Total: comprobante.Total,
          };
          this.setState({
            xmltotales: pagosXML,
            xmlDiagnostico: leerCfdiParaDiagnostico(hola),
          });

          fechaFactura = moment(comprobante.Fecha);
          codigoFactura = (comprobante.Serie ? comprobante.Serie : '') + ' - ' + (comprobante.Folio ? comprobante.Folio : '');
          uuid = timbre?.UUID;
          tipoDeCambio = comprobante.TipoCambio || 1;

          if (insumosSinRegistrar > 0) {
            notification.warning({
              message: insumosSinRegistrar + ' insumos no estan registrados',
            });
            return this.props.history.push("/panel/leerXml", { 
              fileName: e.file.name, 
              fileData: JSON.stringify(hola), 
              origin: '/panel/agregarNotaDeCredito', 
              state: { facturaId: this.state.facturaId } 
            });
          }
          
          if (proveedorId) {
            this.onChangeProveedor(proveedorId, null, true);
          }
          if (uuid) {
            this.onChangeUUID(uuid);
          }

          const moneda = this.state.todasMonedas?.find(
            (valueTodos) => valueTodos.abreviacion?.toLowerCase() === comprobante.Moneda?.toLowerCase()
          );

          if (moneda) {
            monedaId = moneda._id;
          } else {
            message.info('No encontramos la moneda del comprobante');
            monedaId = '60c7e4396465ad440c41c15a';
          }

          const proveedorEncontrado = this.state.todasProveedores?.find(p => p._id === proveedorId);
          const insumosCalculados = insumos.map((insumoRow) =>
            calcularTotalesInsumo(insumoRow, proveedorEncontrado)
          );

          await this.formRef.current.setFieldsValue({ 
            monedaId, 
            tipoDeCambio, 
            insumos: insumosCalculados, 
            fechaFactura, 
            codigoFactura, 
            uuid, 
            proveedorId, 
            facturasRelacionadas 
          });
          
          this.setState({ xmlFile: true });

          facturasRelacionadas.map((value, index) => this.onChangeUUIDRelacionados(value.uuidRelacionado, index));
          
          this.setState({
            archivosXml: [
              {
                ...e.file,
                name: e.file.name,
                status: "success",
              },
            ],
            archivo: e.file, 
            loading: false
          });
        } catch (error) {
          console.error("Error procesando XML:", error);
          message.error("Ocurrió un error al leer el archivo XML.");
          this.setState({ loading: false });
        }
      };

      reader.readAsText(e.file);
    } else {
      message.error("El archivo debe ser un archivo de xml");
      this.setState({ loading: false });
    }
  }
 
  async leerXmlData(state) {
    await this.consultarTodo()

    let proveedorId = this.formRef.current.getFieldValue('proveedorId')

    let proveedor = null

    if (proveedorId) {
      proveedor = this.state.todasProveedores?.find(
        (valueTodos) =>
          valueTodos._id.toString() === proveedorId.toString()
      )
    }


    this.setState({ loading: true });
    let insumosSinRegistrar = 0
    let insumos = []
    let fechaFactura
    let uuid
    let codigoFactura
    let tipoDeCambio
    let monedaId
    const hola = JSON.parse(state.fileData);
    const comprobante = hola?.attributes;
    const emisor = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Emisor"
    )?.attributes;
    const complemento = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Complemento"
    );
    const timbre = complemento.children.find(
      (valueXml) => valueXml.name === "tfd:TimbreFiscalDigital"
    )?.attributes;
    const receptor = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Receptor"
    )?.attributes;
    const conceptos = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:Conceptos"
    )?.children;
    const cfdisRelacionados = hola.children.find(
      (valueXml) => valueXml.name === "cfdi:CfdiRelacionados"
    )?.children;

    if (comprobante.TipoDeComprobante !== 'E') {
      this.setState({
        archivosXml: [
          {
            name: state.fileName,
            status: "success",
          },
        ],
        archivo: state.fileData,
        loading: false
      });
      return message.error(
        "El xml no es una nota de credito"
      );
    }

    if (
      receptor.Rfc?.toLowerCase() === this.state.empresaRfc?.toLowerCase()
    ) {
      if (proveedor && proveedorId) {
        if (proveedor.rfc.toLowerCase() === emisor.Rfc.toLowerCase()) {
          this.setState({
            loading: false
          })
          notification.warning({
            message: 'El proveedor del xml no es el mismo que de la factura',
          })
        }
      } else {
        if (
          !this.state.todasProveedores?.find(
            (valueTodos) =>
              valueTodos.rfc?.toLowerCase() ===
              decodeHTMLEntities(emisor.Rfc ? emisor.Rfc : "").toLowerCase()
          )
        ) {
          this.setState({
            loading: false,
          });
          notification.warning({
            message: "El proveedor no esta registrado",
          });
          return this.props.history.push("/panel/leerXml", {
            fileName: state.fileName,
            fileData: JSON.stringify(hola),
            origin: "/panel/agregarNotaDeCredito",
          }, { facturaId: this.state.facturaId });
        } else {
          const proveedor = this.state.todasProveedores?.find(
            (valueTodos) =>
              valueTodos.rfc?.toLowerCase() ===
              decodeHTMLEntities(emisor.Rfc ? emisor.Rfc : "").toLowerCase()
          );
          proveedorId = proveedor._id;
        }
      }
    } else {
      this.setState({
        archivosXml: [
          {
            name: state.fileName,
            status: "success",
          },
        ],
        archivo: state.fileData,
        loading: false
      });
      return message.error(
        "El rfc del receptor no es igual al de la empresa"
      );
    }

    const facturasRelacionadas = (cfdisRelacionados || []).map(valueRelacionado => {
      const attr = valueRelacionado.attributes;
      return {
        uuidRelacionado: attr.UUID,
        montoPago: cfdisRelacionados?.length === 1 ? comprobante.Total : undefined
      }
    })
    
    const conceptosData = conceptos.map((valueConcepto) => {
      const attr = valueConcepto.attributes;
      let totalImpuestos = 0;
      
      valueConcepto.children
        .find((valueTodos) => valueTodos.name === "cfdi:Impuestos")
        ?.children.find((valueTodos) => valueTodos.name === "cfdi:Traslados")
        ?.children.map((valueImpuesto) => {
          totalImpuestos += Number(valueImpuesto.attributes.Importe || 0);
          return null;
        });

      return {
        codigo: attr.NoIdentificacion,
        descripcion: attr.Descripcion,
        claveProdServ: attr.ClaveProdServ,
        claveUnidad: attr.ClaveUnidad,
        precioUnitario: Number(attr.ValorUnitario),
        cantidad: attr.Cantidad,
        unidad: attr.ClaveUnidad,
        descuento: attr.Descuento ? Math.round((attr.Descuento / attr.Importe) * 1000000) / 10000 : 0,
        impuestos: totalImpuestos,
      };
    });

    const res = await axios.post(
      "insumos/procesarXml",
      { empresaId: this.props.empresaId, proveedorId, conceptos: conceptosData },
      { headers: this.props.headersToken }
    );
    if (res.data.success === 2) {
      insumos = res.data.insumos;
      insumosSinRegistrar = res.data.insumosSinRegistrar;
    } else {
      message.error("Error al procesar los insumos del XML.");
      this.setState({ loading: false });
      return;
    }

    const pagosXML = {
      SubTotal: comprobante.SubTotal - (comprobante.Descuento || 0),
      Total: comprobante.Total,
    };
    await this.setState({
      xmltotales: pagosXML,
      xmlDiagnostico: leerCfdiParaDiagnostico(hola),
    });

    fechaFactura = moment(comprobante.Fecha)
    codigoFactura = (comprobante.Serie ? comprobante.Serie : '') + ' - ' + (comprobante.Folio ? comprobante.Folio : '')
    uuid = timbre.UUID
    tipoDeCambio = comprobante.TipoCambio || 1

    if (insumosSinRegistrar > 0) {
      notification.warning({
        message: insumosSinRegistrar + ' insumos no estan registrados',
      })
      return this.props.history.push("/panel/leerXml", { fileName: state.fileName, fileData: JSON.stringify(hola), origin: '/panel/agregarNotaDeCredito', state: { facturaId: this.state.facturaId } })
    }
    if (proveedorId) {
      this.onChangeProveedor(proveedorId, null, true);
    }
    if (uuid) {
      this.onChangeUUID(uuid)
    }


    const moneda = this.state.todasMonedas?.find(
      (valueTodos) =>
        valueTodos.abreviacion?.toLowerCase() === comprobante.Moneda?.toLowerCase()
    );

    if (moneda) {
      monedaId = moneda._id
    } else {
      message.info('No encontramos la moneda del comprobante')
      monedaId = '60c7e4396465ad440c41c15a'
    }
    
    const proveedorEncontrado = this.state.todasProveedores?.find(p => p._id === proveedorId);
    const insumosCalculados = insumos.map((insumoRow) =>
      calcularTotalesInsumo(insumoRow, proveedorEncontrado)
    );

    await this.formRef.current.setFieldsValue({ 
      monedaId, 
      tipoDeCambio, 
      insumos: insumosCalculados, 
      fechaFactura, 
      codigoFactura, 
      uuid, 
      proveedorId, 
      facturasRelacionadas 
    });
    
    await this.setState({ xmlFile: true });

    facturasRelacionadas.map((value, index) => this.onChangeUUIDRelacionados(value.uuidRelacionado, index))
    this.setState({
      archivosXml: [
        {
          name: state.fileName,
          status: "success",
        },
      ],
      archivo: state.fileData,
      loading: false
    });
  }

  async onChangeInsumo(value, key, insumoSeleccionado) {
    if (!this.formRef.current) return;
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    const insumo = insumoSeleccionado;
    if (!insumo) return
    arrayValue[key].insumoCompleto = insumo;
    arrayValue[key].precioUnitario = insumo.costo;

    const precioUnitario = Number(arrayValue[key].precioUnitario)

    let totalImpuestosPrecioSinImpuestos = 0
    insumo.impuestos.map(valueImpuesto => {
      let totalImpuesto
      if (valueImpuesto.tasaCuota === 1) {
        totalImpuesto = (precioUnitario * (valueImpuesto.monto / 100))
      } else if (valueImpuesto.tasaCuota === 2) {
        totalImpuesto = (precioUnitario + totalImpuestosPrecioSinImpuestos) * (valueImpuesto.monto / 100)
      } else if (valueImpuesto.tasaCuota === 3) {
        totalImpuesto = valueImpuesto.monto
      } else if (valueImpuesto.tasaCuota === 4) {
        let cantidad = arrayValue[key].cantidad
        if (cantidad) {
          totalImpuesto = (arrayValue[key].impuestos || 0) / arrayValue[key].cantidad
        }
      } else if (valueImpuesto.tasaCuota === 5) {
        totalImpuesto = 0
      }
      totalImpuestosPrecioSinImpuestos += totalImpuesto
      return null
    })
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(precioUnitario + totalImpuestosPrecioSinImpuestos)

    const cantidad = arrayValue[key].cantidad
    const descuento = arrayValue[key].descuento || 0

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100))
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento)
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = insumo.impuestos.map(
        //4
        (valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(totalEntrada * (valueImpuesto.monto / 100));
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto =
              round6Decimals((totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100));
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(arrayValue[key].impuestos)
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        }
      );
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos)
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = []


        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion =
              round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null
        })

        insumo.retenciones.map((valueRetencion) => {
          if ((valueRetencion.aplicaCompra === 1 && proveedor.persona === false) || (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) || valueRetencion.aplicaCompra === 3) {
            //7
            let totalRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion =
                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null
        })
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }

    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }
  async onChangePrecioCantidadDescuento(value, key) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    
    const insumo = arrayValue[key]?.insumoCompleto; 
    if (!insumo) return
    const precioUnitario = Number(arrayValue[key].precioUnitario)

    let totalImpuestosPrecioSinImpuestos = 0
    insumo.impuestos.map(valueImpuesto => {
      let totalImpuesto
      if (valueImpuesto.tasaCuota === 1) {
        totalImpuesto = (precioUnitario * (valueImpuesto.monto / 100))
      } else if (valueImpuesto.tasaCuota === 2) {
        totalImpuesto = (precioUnitario + totalImpuestosPrecioSinImpuestos) * (valueImpuesto.monto / 100)
      } else if (valueImpuesto.tasaCuota === 3) {
        totalImpuesto = valueImpuesto.monto
      } else if (valueImpuesto.tasaCuota === 4) {
        let cantidad = arrayValue[key].cantidad
        if (cantidad) {
          totalImpuesto = (arrayValue[key].impuestos || 0) / arrayValue[key].cantidad
        }
      } else if (valueImpuesto.tasaCuota === 5) {
        totalImpuesto = 0
      }
      totalImpuestosPrecioSinImpuestos += totalImpuesto
      return null
    })
    arrayValue[key].precioUnitarioConImpuestos = round2Decimals(Number(precioUnitario) + Number(totalImpuestosPrecioSinImpuestos))
    const cantidad = arrayValue[key].cantidad
    const descuento = arrayValue[key].descuento || 0

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100))
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento)
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = insumo.impuestos.map(
        //4
        (valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(totalEntrada * (valueImpuesto.monto / 100));
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto =
              round6Decimals((totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100));
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(arrayValue[key].impuestos)
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        }
      );
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos)
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = []

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion =
              round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null
        })

        insumo.retenciones.map((valueRetencion) => {
          if ((valueRetencion.aplicaCompra === 1 && proveedor.persona === false) || (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) || valueRetencion.aplicaCompra === 3) {
            //7
            let totalRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion =
                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null
        })
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }
  async onChangePrecioImpuestos(value, key) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proveedorId = await this.formRef.current.getFieldValue("proveedorId");
    
    const insumo = arrayValue[key]?.insumoCompleto;
    if (!insumo) return

    const precioUnitarioConImpuestos = arrayValue[key].precioUnitarioConImpuestos

    let totalPorcentajeImpuestos = 1
    let totalCantidadImpuestos = 0
    insumo.impuestos.map(valueImpuesto => {
      if (valueImpuesto.tasaCuota === 1) {
        totalPorcentajeImpuestos += (valueImpuesto.monto / 100)
      } else if (valueImpuesto.tasaCuota === 2) {
        totalPorcentajeImpuestos += totalPorcentajeImpuestos * (valueImpuesto.monto / 100)
      } else if (valueImpuesto.tasaCuota === 3) {
        totalCantidadImpuestos = valueImpuesto.monto
      }
      return null
    })


    const precioUnitario = (precioUnitarioConImpuestos / totalPorcentajeImpuestos) + totalCantidadImpuestos
    arrayValue[key].precioUnitario = precioUnitario
    const cantidad = arrayValue[key].cantidad
    const descuento = arrayValue[key].descuento || 0

    if ((precioUnitario || precioUnitario === 0) && cantidad && insumo) {
      //1
      const subtotal = round6Decimals(cantidad * precioUnitario);
      //2
      const totalDescuento = round6Decimals(subtotal * (descuento / 100))
      //3
      const totalEntrada = round6Decimals(subtotal - totalDescuento)
      arrayValue[key].subtotal = totalEntrada;

      let totalImpuestos = 0;
      let arrayImpuestos = insumo.impuestos.map(
        //4
        (valueImpuesto) => {
          let totalImpuesto;
          if (valueImpuesto.tasaCuota === 1) {
            totalImpuesto = round6Decimals(totalEntrada * (valueImpuesto.monto / 100));
          } else if (valueImpuesto.tasaCuota === 2) {
            totalImpuesto =
              round6Decimals((totalEntrada + totalImpuestos) * (valueImpuesto.monto / 100));
          } else if (valueImpuesto.tasaCuota === 3) {
            totalImpuesto = round6Decimals(cantidad * valueImpuesto.monto);
          } else if (valueImpuesto.tasaCuota === 4) {
            totalImpuesto = round6Decimals(arrayValue[key].impuestos)
          } else if (valueImpuesto.tasaCuota === 5) {
            totalImpuesto = 0
          }
          totalImpuestos += totalImpuesto;
          return {
            descripcionFactura: valueImpuesto.descripcionFactura,
            totalImpuestos: totalImpuesto,
          };
        }
      );
      arrayValue[key].impuestos = totalImpuestos;
      arrayValue[key].arrayImpuestos = arrayImpuestos;
      //5
      const total = round2Decimals(arrayValue[key].subtotal + totalImpuestos)
      arrayValue[key].total = total;

      if (proveedorId) {
        //Consultar proveedor

        const proveedor = this.state.todasProveedores.find(
          (valueP) => valueP._id === proveedorId
        );
        //6
        let totalRetenciones = 0;
        let arrayRetenciones = []

        proveedor.retenciones.map((valueRetencion) => {
          //7
          let totalRetencion;
          if (valueRetencion.tasaCuota === 1) {
            totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
          } else if (valueRetencion.tasaCuota === 2) {
            totalRetencion =
              round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
          }
          totalRetenciones += totalRetencion;
          arrayRetenciones.push({
            descripcionFactura: valueRetencion.descripcionFactura,
            totalRetenciones: totalRetencion,
          });
          return null
        })

        insumo.retenciones.map((valueRetencion) => {
          if ((valueRetencion.aplicaCompra === 1 && proveedor.persona === false) || (valueRetencion.aplicaCompra === 2 && proveedor.persona === true) || valueRetencion.aplicaCompra === 3) {
            //7
            let totalRetencion;
            if (valueRetencion.tasaCuota === 1) {
              totalRetencion = round6Decimals(totalEntrada * (valueRetencion.monto / 100));
            } else if (valueRetencion.tasaCuota === 2) {
              totalRetencion =
                round6Decimals((totalEntrada + totalRetenciones) * (valueRetencion.monto / 100));
            }
            totalRetenciones += totalRetencion;
            arrayRetenciones.push({
              descripcionFactura: valueRetencion.descripcionFactura,
              totalRetenciones: totalRetencion,
            });
          }
          return null
        })
        arrayValue[key].retenciones = totalRetenciones;
        arrayValue[key].arrayRetenciones = arrayRetenciones;
      }
    }
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }

  async onChangeProveedor(value, _, dejarInsumos) {
    const proveedor = this.state.todasProveedores.find(valueProv => valueProv._id === value)
    if (!proveedor.tipoProveedorId) {
      const nombre = proveedor.persona ? proveedor.razonSocial : `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`
      this.abrirElegirTipoDeProveedor(proveedor._id, nombre)
    }
    const fechaFactura = await this.formRef.current.getFieldValue("fechaFactura");
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    this.formRef.current.setFieldsValue({ insumos: dejarInsumos ? arrayValue : [], fechaPago: moment(fechaFactura).add(proveedor.diasCredito, 'days'), diasCredito: proveedor.diasCredito || 0 })
    
    this.setState({ loading: false })
  }

  atras() {
    this.props.history.push("/panel/notasDeCreditoCompra");
  }

  onChangeUUID(value) {
    //Los uuid que no son del SAT (folios internos, capturas a medias) no se revisan
    if (!esUuidSat(value)) {
      if (this.state.uuidDuplicado) {
        this.setState({ uuidDuplicado: false, mensajeUuidDuplicado: undefined });
      }
      return;
    }
    axios
      .post(
        "facturas/checarUUID",
        { uuid: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.existeUUID === 1) {
          const mensaje =
            res.data.message ||
            "No se puede registrar: la nota de crédito ya existe en el sistema";
          this.setState({ uuidDuplicado: true, mensajeUuidDuplicado: mensaje });
          message.error(mensaje);
        } else {
          this.setState({ uuidDuplicado: false, mensajeUuidDuplicado: undefined });
        }
      });
  }

  async actualizarBoton() {
    await this.consultarTodo()
    let arrayValue = this.formRef.current.getFieldValue("insumos");
    if (arrayValue?.length > 0) {
      arrayValue.map((valueInsumo, key) => this.onChangePrecioCantidadDescuento(undefined, key))
    }
  }

  onChangeUUIDRelacionados(value, arrayValue) {
    const proveedorId = this.formRef.current.getFieldValue("proveedorId")
    if (value && proveedorId) {
      axios.post(
        "facturas/checarUUIDRelacionados",
        { uuid: value, empresaId: this.props.empresaId, proveedorId: proveedorId },
        { headers: this.props.headersToken }
      ).then((res) => {
        if (res.data.success === 2) {
          if (res.data.existeUUID === 1) {
            const facturasRelacionadas = this.formRef.current.getFieldValue("facturasRelacionadas") || []
            const nuevasFacturasRelacionadas = [...facturasRelacionadas]
            nuevasFacturasRelacionadas[arrayValue].codigoFactura = res.data.codigoFactura
            nuevasFacturasRelacionadas[arrayValue].tipoDeCambioCompra = res.data.tipoDeCambio
            nuevasFacturasRelacionadas[arrayValue].tipoDeCambio = res.data.tipoDeCambio
            nuevasFacturasRelacionadas[arrayValue].moneda = res.data.moneda
            nuevasFacturasRelacionadas[arrayValue].facturaId = res.data.facturaId
            nuevasFacturasRelacionadas[arrayValue].totalPagar = res.data.totalPagar
            nuevasFacturasRelacionadas[arrayValue].total = res.data.total
            nuevasFacturasRelacionadas[arrayValue].subtotal = res.data.subtotal
            this.formRef.current.setFieldsValue({ facturasRelacionadas: nuevasFacturasRelacionadas })
          } else {
            const facturasRelacionadas = this.formRef.current.getFieldValue("facturasRelacionadas") || []
            const nuevasFacturasRelacionadas = [...facturasRelacionadas]
            nuevasFacturasRelacionadas[arrayValue].codigoFactura = undefined
            nuevasFacturasRelacionadas[arrayValue].tipoDeCambioCompra = undefined
            nuevasFacturasRelacionadas[arrayValue].tipoDeCambio = undefined
            nuevasFacturasRelacionadas[arrayValue].moneda = undefined
            this.formRef.current.setFieldsValue({ facturasRelacionadas: nuevasFacturasRelacionadas })
            message.error(res.data.message || "El UUIID relacionado " + (value || "") + " no existe en nuestras facturas");
          }
        } else {
          message.error(res.data.message || "El UUIID relacionado " + (value || "") + " no existe en nuestras facturas");
        }
      }).catch((err) => {
        message.error("Error al verificar los UUID relacionados");
      });

    } else {
      message.warning("No se pudo verificar el UUID relacionado, falta el proveedor");
    }
  }

  async onChangeFacturaRelacionada(valueId, facturaEncontrada, arrayValue) {
    this.setState({ loading: true });
    let factura
    if (facturaEncontrada) {
      factura = facturaEncontrada;
      const yaExiste = this.state.todasFacturas.find(i => i._id === factura._id);
      if (!yaExiste) {
        await this.setState(prev => ({
          todasFacturas: [...prev.todasFacturas, factura]
        }));
      }
    } else {
      factura = this.state.todasFacturas.find(
        (valueFacturas) => valueFacturas._id === valueId
      );
    }
    const facturasRelacionadas = this.formRef.current.getFieldValue("facturasRelacionadas") || []
    const nuevasFacturasRelacionadas = [...facturasRelacionadas]
    nuevasFacturasRelacionadas[arrayValue].codigoFactura = factura.codigoFactura
    nuevasFacturasRelacionadas[arrayValue].tipoDeCambioCompra = factura.tipoDeCambio
    nuevasFacturasRelacionadas[arrayValue].tipoDeCambio = factura.tipoDeCambio
    nuevasFacturasRelacionadas[arrayValue].moneda = factura.moneda
    nuevasFacturasRelacionadas[arrayValue].totalPagar = factura.totalPagar
    nuevasFacturasRelacionadas[arrayValue].total = factura.total
    nuevasFacturasRelacionadas[arrayValue].subtotal = factura.subtotal
    this.formRef.current.setFieldsValue({ facturasRelacionadas: nuevasFacturasRelacionadas })
    this.setState({ loading: false });
  }

  buscarInsumo = (valor) => {
    this.setState({ busquedaInsumo: valor, insumoResaltado: null });
    if (!valor) return;

    const insumos = this.formRef.current?.getFieldValue("insumos") || [];
    const texto = valor.toLowerCase();
    
    const index = insumos.findIndex((insumo) => {
      const infoInsumo = insumo.insumoCompleto;
      if (!infoInsumo) return false;
      
      return (
        String(infoInsumo.descripcion || "").toLowerCase().includes(texto) ||
        String(infoInsumo.codigo || "").toLowerCase().includes(texto) ||
        String(infoInsumo.clave || "").toLowerCase().includes(texto) ||
        String(infoInsumo.codigoBarras || "").toLowerCase().includes(texto)
      );
    });

    if (index === -1) {
      message.warning("No se encontró ningún insumo con ese criterio");
      return;
    }

    this.setState({ insumoResaltado: index });

    const fila = document.getElementById(`insumo-row-${index}`);
    if (fila) {
      fila.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  renderProyectoCard() {
    return (
      <FormItem shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const proyectoId = getFieldValue("proyectoId");
          const proveedorId = getFieldValue("proveedorId");
          const proyecto = proyectoId
            ? this.state.todasProyectos?.find((v) => v._id === proyectoId)
            : null;
          const proveedor = proveedorId
            ? this.state.todasProveedores?.find((v) => v._id === proveedorId)
            : null;

          if (!proyecto && !proveedor) return null;

          const proveedorSections = proveedor
            ? [
                {
                  title: "Datos generales",
                  icon: <InfoCircleOutlined />,
                  iconColor: "#00BFD6",
                  lg: 14,
                  items: [
                    {
                      label: "Nombre",
                      value: proveedor.nombre
                        ? `${proveedor.nombre} ${proveedor.apellidoPaterno} ${proveedor.apellidoMaterno}`
                        : proveedor.razonSocial || "-",
                      bold: true,
                    },
                    { label: "RFC",      value: proveedor.rfc      || "-" },
                    { label: "Correo",   value: proveedor.correo   || "-" },
                    { label: "Teléfono", value: proveedor.telefono || "-" },
                    { label: "Celular",  value: proveedor.celular  || "-" },
                  ],
                },
                {
                  title: "Contacto",
                  icon: <PhoneFilled />,
                  iconColor: "#DB2777",
                  lg: 10,
                  items: [
                    { label: "Nombre",          value: proveedor.nombreContacto   || "-" },
                    { label: "Teléfono",        value: proveedor.telefonoContacto || "-" },
                    { label: "Correo",          value: proveedor.correoContacto   || "-" },
                    { label: "Días de crédito", value: proveedor.diasCredito       ?? "-" },
                  ],
                },
              ]
            : [];

          if (!proyecto) {
            return (
              <Row>
                <InfoCard title="PROVEEDOR" accentColor="#00BFD6" compact sections={proveedorSections} />
              </Row>
            );
          }

          return (
            <Row>
              <InfoCard
                title="PROYECTO"
                accentColor="#00BFD6"
                icon={<InfoCircleOutlined />}
                compact
                sections={[
                  {
                    title: "Información General",
                    icon: <InfoCircleOutlined />,
                    iconColor: "#00BFD6",
                    lg: 8,
                    items: [
                      { label: "Nombre",      value: proyecto.nombre      || "-" },
                      { label: "Descripción", value: proyecto.descripcion || "-" },
                    ],
                  },
                  {
                    title: proyecto.calle ? "Dirección" : "Vehículo",
                    icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
                    iconColor: "#C9DF00",
                    lg: 8,
                    items: proyecto.calle
                      ? [{ label: "Calle", value: `${proyecto.calle} #${proyecto.numeroCalle || "-"}` }]
                      : [
                          { label: "Marca",  value: proyecto.marca  || "-" },
                          { label: "Modelo", value: proyecto.modelo || "-" },
                          { label: "Placas", value: proyecto.placas || "-" },
                        ],
                  },
                  {
                    title: "Detalles",
                    icon: <CarOutlined />,
                    iconColor: "#FF6A0D",
                    lg: 8,
                    items: [
                      { label: "Tipo", value: proyecto.calle ? "Dirección física" : "Vehículo" },
                      { label: "ID",   value: proyecto._id ? proyecto._id.slice(-6).toUpperCase() : "-" },
                    ],
                  },
                ]}
                splitWith={
                  proveedor
                    ? {
                        title: "PROVEEDOR",
                        accentColor: "#00BFD6",
                        icon: <UserOutlined />,
                        compact: true,
                        sections: proveedorSections,
                      }
                    : undefined
                }
              />
            </Row>
          );
        }}
      </FormItem>
    );
  }

  getInsumosColumns() {
    return [
      { title: "Clave",  width: "5%" },
      { title: "Insumo", width: "25%" },
      { title: "Unidad", width: "5%" },
      { title: "P.U.",   width: "10%" },
      { title: "P.U. c/Imp.", width: "10%" },
      { title: "Cant.",  width: "10%" },
      { title: "Desc.",  width: "10%" },
      { title: "Subtotal/Imp./Total", width: "12%" },
      { title: "",       width: "10%"  },
    ];
  }

  getFacturasColumns() {
    return [
      { title: "Factura Relacionada", width: "35%" },
      { title: "Código Factura",      width: "18%" },
      { title: "T. C. Compra",        width: "17%" },
      { title: "Monto a aplicar",     width: "20%" },
      { title: "",                    width: "10%" },
    ];
  }

  renderInsumoRow({ key, name, fieldKey, restField, arrayKey, remove }) {
    const insumos = this.formRef.current?.getFieldValue("insumos");
    return (
      <React.Fragment key={key}>
        <tr
          id={`insumo-row-${arrayKey}`}
          style={
            this.state.insumoResaltado === arrayKey
              ? { backgroundColor: "#fffbe6", outline: "2px solid #faad14", transition: "all 0.3s" }
              : {}
          }
        >
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const insumo = getFieldValue(['insumos', arrayKey, 'insumoCompleto']);
                return (
                  <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                    {insumo?.clave || '-'}
                  </div>
                );
              }}
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "insumoId"]} fieldKey={[arrayKey, "insumoId"]} required noStyle>
              <SelectInsumosItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                sinBorde autoFocus width="100%" dropdownMatchSelectWidth={600}
                placeholder="Insumo" tiposInsumos="ordenDeCompra"
                proveedorId={this.formRef.current?.getFieldValue("proveedorId")}
                onChange={(value, insumo) => this.onChangeInsumo(value, arrayKey, insumo)}
                insumoPreCargado={insumos ? insumos[arrayKey]?.insumoCompleto : null}
                ocultarCodigoYUnidad
              />
            </FormItem>
          </td>
             <td className="td-border">
              <FormItem noStyle shouldUpdate>
                {({ getFieldValue }) => {
                  const insumo = getFieldValue(['insumos', arrayKey, 'insumoCompleto']);
                  return (
                    <div style={{ fontSize: '14px', textAlign: 'center', color: '#868585' }}>
                      {insumo?.unidad || '-'}
                    </div>
                  );
                }}
              </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "precioUnitario"]} fieldKey={[arrayKey, "precioUnitario"]} noStyle required numberCero>
              <InputNumberItem sinBorde placeholder="P.U." dinero
                onChange={(value) => this.onChangePrecioCantidadDescuento(value, arrayKey)} />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const arr = getFieldValue("insumos");
                const disabled = arr?.[arrayKey]?.insumoCompleto
                  ? !arr[arrayKey].insumoCompleto?.impuestos?.[0]?.combustible
                  : true;
                return (
                  <FormItem name={[name, "precioUnitarioConImpuestos"]} noStyle required numberCero shouldUpdate>
                    <InputNumberItem sinBorde disabled={disabled} placeholder="P.U. c/Imp."
                      onChange={(value) => this.onChangePrecioImpuestos(value, arrayKey)}
                      dinero={!disabled} dineroDisabled={disabled} />
                  </FormItem>
                );
              }}
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "cantidad"]} fieldKey={[arrayKey, "cantidad"]} required number noStyle>
              <InputNumberItem sinBorde placeholder="Cant."
                onChange={(value) => this.onChangePrecioCantidadDescuento(value, arrayKey)} />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "descuento"]} fieldKey={[arrayKey, "descuento"]} required numberCero noStyle shouldUpdate initialValue={0}>
              <InputNumberItem sinBorde placeholder="Desc." porcentaje max={100}
                onChange={(value) => this.onChangePrecioCantidadDescuento(value, arrayKey)} />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const arr         = getFieldValue("insumos");
                const subtotal    = arr?.[arrayKey]?.subtotal || 0;
                const impuestos   = arr?.[arrayKey]?.impuestos || 0;
                const total       = arr?.[arrayKey]?.total || 0;
                const combustible = !!arr?.[arrayKey]?.insumoCompleto?.impuestos?.[0]?.combustible;

                return (
                  <div className="celda-totales" style={{ fontSize: "12px" }}>
                    <div>{dineroDisabledMask(subtotal)}</div>

                    {combustible ? (
                      <FormItem name={[name, "impuestos"]} required numberCero noStyle>
                        <InputNumberItem
                          sinBorde
                          dinero
                          placeholder="Impuestos"
                          onChange={(value) => this.onChangePrecioCantidadDescuento(value, arrayKey)}
                        />
                      </FormItem>
                    ) : (
                      <div>{dineroDisabledMask(impuestos)}</div>
                    )}

                    <div className="total-bold">
                      Total: {dineroDisabledMask(total)}
                    </div>
                  </div>
                );
              }}
            </FormItem>

              <FormItem {...restField} name={[name, "subtotal"]} fieldKey={[arrayKey, "subtotal"]} hidden required numberCero>
                <InputNumberItem />
              </FormItem>

              <FormItem {...restField} name={[name, "impuestos"]} fieldKey={[arrayKey, "impuestos"]} hidden required numberCero>
                <InputNumberItem />
              </FormItem>

              <FormItem {...restField} name={[name, "total"]} fieldKey={[arrayKey, "total"]} hidden required numberCero>
                <InputNumberItem />
              </FormItem>
          </td>
          <td className="td-border-sin-right">
          <Row className="acciones-container">
            <Col span={24}>
              <Space
                style={{
                  width: "100%",display: "flex", justifyContent: "space-between",alignItems: "center"
                }}
                size={4}
                className="acciones-container"
              >
              <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                  <ButtonItem
                    rojo2
                    icon={<DeleteOutlined />}
                    onClick={() => remove(name)}
                    size="small"
                  />
                </Tooltip>
                </Space>
              </Col>
            </Row>
          </td>
        </tr>
      </React.Fragment>
    );
  }

  renderFacturaRow({ key, name, fieldKey, restField, arrayKey, remove }) {
    return (
      <React.Fragment key={key}>
        <tr>
          <td className="td-border">
            <FormItem {...restField} name={[name, "facturaId"]} fieldKey={[arrayKey, "facturaId"]} required noStyle>
              <SelectFacturasItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                sinBorde autoFocus dropdownMatchSelectWidth={600} width="100%" placeholder="Factura"
                proveedorId={this.formRef.current ? this.formRef.current.getFieldValue("proveedorId") : null}
                onChange={(valueId, factura) => this.onChangeFacturaRelacionada(valueId, factura, arrayKey)}
              />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem {...restField} name={[name, "codigoFactura"]} fieldKey={[arrayKey, "codigoFactura"]} noStyle>
              <InputItem disabled sinBorde />
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const pagar     = getFieldValue("pagarFactura");
                const arr       = getFieldValue("facturasRelacionadas") || [];
                const monedaId  = arr[arrayKey]?.monedaId;
                const monedaAbr = arr[arrayKey]?.moneda?.abreviacion || "";
                return (
                  <FormItem {...restField} name={[name, "tipoDeCambioCompra"]} fieldKey={[arrayKey, "tipoDeCambioCompra"]}
                    required={!!pagar} noStyle number initialValue={1}
                  >
                    <InputNumberItem sinBorde disabled={!pagar || monedaId === "60c7e4396465ad440c41c15a"}
                      dinero placeholder={`T. C. ${monedaAbr}`} />
                  </FormItem>
                );
              }}
            </FormItem>
          </td>
          <td className="td-border">
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const pagar = getFieldValue("pagarFactura");
                return (
                  <FormItem {...restField} name={[name, "montoPago"]} fieldKey={[arrayKey, "montoPago"]}
                    required={!!pagar} noStyle number
                  >
                    <InputItem sinBorde placeholder={pagar ? "0.00" : "Deshabilitado"} disabled={!pagar} />
                  </FormItem>
                );
              }}
            </FormItem>
          </td>
          <td className="td-border-sin-right">
          <Row className="acciones-container">
            <Col span={24}>
              <Space
                style={{
                  width: "100%",display: "flex", justifyContent: "space-between",alignItems: "center"
                }}
                size={4}
                className="acciones-container"
              >
              <Tooltip title="Eliminar" placement="top" overlayInnerStyle={{ fontSize: "10px" }}>
                  <ButtonItem
                    rojo2
                    icon={<DeleteOutlined />}
                    onClick={() => remove(name)}
                    size="small"
                  />
                </Tooltip>
                </Space>
              </Col>
            </Row>
          </td>
        </tr>
        <tr>
          <td className="td-border" colSpan={5} style={{ padding: "6px 10px" }}>
            <FormItem noStyle shouldUpdate>
              {({ getFieldValue }) => {
                const pagar = getFieldValue("pagarFactura");
                if (!pagar) return null;
                const arr       = getFieldValue("facturasRelacionadas") || [];
                const monedaAbr = arr[arrayKey]?.moneda?.abreviacion;
                const tcFactura = arr[arrayKey]?.tipoDeCambio;
                if (!monedaAbr && !tcFactura) return null;
                return (
                  <div style={{ display: "flex", gap: 20, justifyContent: "center" }}>
                    {monedaAbr ? <span>Moneda factura: {monedaAbr}</span> : null}
                    {tcFactura ? <span>Tipo de cambio factura: {dineroDisabledMask(tcFactura)}</span> : null}
                  </div>
                );
              }}
            </FormItem>
          </td>
        </tr>
      </React.Fragment>
    );
  }

  /*
    Arma el diagnostico con lo que el bloque de totales ya tiene acumulado. Se calcula al abrir el
    modal y no en cada render, porque el FormItem con shouldUpdate se re-renderiza en cada tecla.
  */
  abrirDiagnosticoCuadre(acumulados) {
    const capturado = construirCapturadoDesdeTotales({
      ...acumulados,
      arrayInsumos: this.formRef.current.getFieldValue("insumos"),
      resolverInsumo: (valueRenglon) => valueRenglon.insumoCompleto,
      proveedor: this.state.todasProveedores?.find(
        (valueTodos) => valueTodos._id === this.formRef.current.getFieldValue("proveedorId")
      ),
      ajusteMax: this.state.ajusteMax,
    });
    this.setState({
      modalDiagnosticoVisible: true,
      diagnostico: diagnosticarCuadreFactura({ xml: this.state.xmlDiagnostico, capturado }),
      ajusteContexto: {
        subtotalVI: acumulados.subtotalVI,
        cuentasProveedorVI: acumulados.cuentasProveedorVI,
        arrayImpuestos: acumulados.arrayImpuestos,
        arrayRetenciones: acumulados.arrayRetenciones,
      },
    });
  }

  /*
    Misma mecanica que en las facturas: reparte la diferencia entre los campos de ajuste que ya
    existen en esta pantalla (ajusteSubtotal y ajuste<descripcionFactura>), topada por ajusteMax.
  */
  ajustarTotalesAutomaticamente({ subtotalVI, cuentasProveedorVI, arrayImpuestos, arrayRetenciones }) {
    const resultado = calcularAjusteAutomaticoFactura({
      subtotalVI,
      cuentasProveedorVI,
      arrayImpuestos,
      arrayRetenciones,
      xmltotales: this.state.xmltotales,
      ajusteMax: this.state.ajusteMax,
    });
    this.formRef.current.setFieldsValue(resultado.ajustes);
    if (resultado.restante !== 0) {
      message.warning(
        "No fue posible cubrir toda la diferencia automáticamente, queda una diferencia de $" +
          Math.abs(resultado.restante).toFixed(2) +
          " por el límite de ajuste configurado."
      );
    }
  }

  getObservacionesConfig() {
    return {
      totales: (
        <div style={{ marginTop: 8 }}>
          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => {
              let arrayInsumos = getFieldValue("insumos") || [];
              let ajusteSubtotal = getFieldValue('ajusteSubtotal') || 0
              let arrayRetenciones = [];
              let cuentasProveedor = 0;
              let subtotal = 0;
              let subtotalVI = 0
              let arrayImpuestos = [];
              let total = 0;
              arrayInsumos.map((value) => {
                if (value) {
                  if (
                    value.subtotal &&
                    value.total &&
                    value.arrayImpuestos
                  ) {
                    subtotal += value.subtotal;
                    subtotalVI += value.subtotal;
                    total += value.subtotal;
                    value.arrayImpuestos.map((valueImpuestos) => {
                      let index = arrayImpuestos.findIndex(
                        (valueImpuestosAnterios) =>
                          valueImpuestosAnterios.descripcionFactura ===
                          valueImpuestos.descripcionFactura
                      );
                      if (index !== -1) {
                        let newItem = {
                          totalImpuestos:
                            arrayImpuestos[index].totalImpuestos +
                            valueImpuestos.totalImpuestos,
                          descripcionFactura:
                            valueImpuestos.descripcionFactura,
                        };
                        arrayImpuestos.splice(index, 1, newItem);
                      } else {
                        arrayImpuestos.push({
                          totalImpuestos: valueImpuestos.totalImpuestos,
                          descripcionFactura:
                            valueImpuestos.descripcionFactura,
                        });
                      }
                      return null;
                    });
                    if (value.arrayRetenciones) {
                      value.arrayRetenciones.map((valueRetenciones) => {
                        let index = arrayRetenciones.findIndex(
                          (valueRetencionesAnterios) =>
                            valueRetencionesAnterios.descripcionFactura ===
                            valueRetenciones.descripcionFactura
                        );
                        cuentasProveedor += round2Decimals(valueRetenciones.totalRetenciones);
                        if (index !== -1) {
                          let newItem = {
                            totalRetenciones:
                              arrayRetenciones[index].totalRetenciones +
                              valueRetenciones.totalRetenciones,
                            descripcionFactura:
                              valueRetenciones.descripcionFactura,
                          };
                          arrayRetenciones.splice(index, 1, newItem);
                        } else {
                          arrayRetenciones.push({
                            totalRetenciones: valueRetenciones.totalRetenciones,
                            descripcionFactura:
                              valueRetenciones.descripcionFactura,
                          });
                        }
                        return null;
                      });
                    }
                  }
                }
                return null;
              });
              // Retenciones antes de aplicarles el ajuste manual: es lo que necesita el ajuste
              // automatico para saber cuanto puede mover.
              let cuentasProveedorVI = cuentasProveedor
              subtotal += ajusteSubtotal
              total += ajusteSubtotal
              arrayImpuestos = arrayImpuestos.map(valueImpuesto => {
                let ajusteImpuesto = getFieldValue('ajuste' + valueImpuesto.descripcionFactura) || 0
                total += round2Decimals(valueImpuesto.totalImpuestos + ajusteImpuesto)
                return {
                  ...valueImpuesto,
                  totalImpuestos: round2Decimals(valueImpuesto.totalImpuestos + ajusteImpuesto),
                  totalImpuestosVI: valueImpuesto.totalImpuestos
                }
              })
              arrayRetenciones = arrayRetenciones.map(valueRetencion => {
                let ajusteRetencion = getFieldValue('ajuste' + valueRetencion.descripcionFactura) || 0
                cuentasProveedor += ajusteRetencion
                return {
                  ...valueRetencion,
                  totalRetenciones: (valueRetencion.totalRetenciones + ajusteRetencion),
                  totalRetencionesVI: valueRetencion.totalRetenciones
                };
              });

              const diferenciaXml = round2Decimals(
                round2Decimals(Number(this.state.xmltotales?.Total || 0)) -
                  round2Decimals(total - cuentasProveedor)
              );
              return (
                <>
                {this.state.xmlFile && (
                  <div style={{ textAlign: "right", marginBottom: 8 }}>
                    <Space wrap>
                      <ButtonItem
                        {...(diferenciaXml === 0 ? { blanco: true } : { rojo: true })}
                        icon={<QuestionCircleOutlined />}
                        onClick={() =>
                          this.abrirDiagnosticoCuadre({
                            subtotal,
                            ajusteSubtotal,
                            total,
                            cuentasProveedor,
                            arrayImpuestos,
                            arrayRetenciones,
                            subtotalVI,
                            cuentasProveedorVI,
                          })
                        }
                      >
                        {diferenciaXml === 0
                          ? "Comparar con XML"
                          : "¿Por qué no cuadra? " + dineroDisabledMask(diferenciaXml)}
                      </ButtonItem>
                      <ButtonItem
                        ambar
                        icon={<ToolOutlined />}
                        onClick={() =>
                          this.ajustarTotalesAutomaticamente({
                            subtotalVI,
                            cuentasProveedorVI,
                            arrayImpuestos,
                            arrayRetenciones,
                          })
                        }
                      >
                        Ajustar automáticamente
                      </ButtonItem>
                    </Space>
                  </div>
                )}
                <table className="table totales-table" style={{ borderCollapse: "collapse", width: "100%", margin: 0 }}>
                  <tbody>
                    <tr>
                      <th className="td-totales-center" style={{ width: "25%" }}></th>
                      <td className="td-totales-center" style={{ width: "15%" }}>
                        <Tag style={{ backgroundColor: "#f5f5f5", borderColor: "#d9d9d9", color: "#595959", fontWeight: 600, padding: "2px 50px", borderRadius: "6px" }}>
                          Ajuste
                        </Tag>
                      </td>
                      <td className="td-totales-center" style={{ width: "25%" }}></td>
                      {this.state.xmlFile && (
                        <td className="td-totales-center" style={{ width: "25%" }}>
                          <Tag style={{ backgroundColor: "#ecfff2", borderColor: "#85d89f", color: "#008f2d",fontWeight: 600, padding: "2px 60px", borderRadius: "6px" }}>
                            XML
                          </Tag>
                        </td>
                      )}
                    </tr>
                    <tr>
                      <th className="th-totales" style={{ width: "25%" }}>Subtotal</th>
                      <td className="td-totales-right" style={{ width: "25%" }}>
                        <FormItem
                          name="ajusteSubtotal"
                          numberNegativo
                          noStyle
                          max={this.state.ajusteMax}
                          min={Math.max(-this.state.ajusteMax, -subtotalVI)}
                          type="number"
                          required
                          initialValue={0}
                        >
                          <InputNumberItem step={0.01} sinBorde dinero precision={2}
                            placeholder={"Max: ±" + this.state.ajusteMax} />
                        </FormItem>
                      </td>
                      <td className="td-totales-right" style={{ width: "25%" }}>
                        {dineroDisabledMask(subtotal)}
                      </td>
                      {this.state.xmlFile && (
                        <td className="td-totales-right" style={{ width: "25%" }}>
                          {dineroDisabledMask(this.state.xmltotales.SubTotal)}
                        </td>
                      )}
                    </tr>
                  </tbody>
                  {arrayImpuestos.map((valueArray) => (
                    <tbody key={valueArray.descripcionFactura}>
                      <tr>
                        <th className="th-totales" style={{ width: "25%" }}>
                          {valueArray.descripcionFactura}
                        </th>
                        <td className="td-totales-right" style={{ width: "25%" }}>
                          <FormItem
                            name={"ajuste" + valueArray.descripcionFactura}
                            numberNegativo
                            noStyle
                            max={this.state.ajusteMax}
                            min={Math.max(-this.state.ajusteMax, -valueArray.totalImpuestosVI)}
                            type="number"
                            required
                            initialValue={0}
                            precision={2}
                          >
                            <InputNumberItem step={0.01} sinBorde dinero
                              placeholder={"Max: ±" + this.state.ajusteMax} />
                          </FormItem>
                        </td>
                        <td className="td-totales-right">
                          {dineroDisabledMask(valueArray.totalImpuestos)}
                        </td>
                        {this.state.xmlFile && (
                          <td className="td-totales-right"></td>
                        )}
                      </tr>
                    </tbody>
                  ))}
                  <tbody>
                    <tr>
                      <th className="th-totales" style={{ width: "25%" }}>Total</th>
                      <td className="td-totales-right" style={{ width: "25%" }}></td>
                      <td className="td-totales-right" style={{ width: "25%" }}>
                        {dineroDisabledMask(total)}
                      </td>
                      {this.state.xmlFile && (
                        <td className="td-totales-right" style={{ width: "25%" }}></td>
                      )}
                    </tr>
                  </tbody>
                  {arrayRetenciones.map((value) => (
                    <tbody key={value.descripcionFactura}>
                      <tr>
                        <th className="th-totales" style={{ width: "25%" }}>
                          {value.descripcionFactura}
                        </th>
                        <td className="td-totales-right" style={{ width: "25%" }}>
                          <FormItem
                            name={"ajuste" + value.descripcionFactura}
                            numberNegativo
                            noStyle
                            max={this.state.ajusteMax}
                            min={Math.max(-this.state.ajusteMax, -value.totalRetencionesVI)}
                            type="number"
                            required
                            initialValue={0}
                            precision={2}
                          >
                            <InputNumberItem step={0.01} sinBorde dinero
                              placeholder={"Max: ±" + this.state.ajusteMax} />
                          </FormItem>
                        </td>
                        <td className="td-totales-right">
                          {dineroDisabledMask(value.totalRetenciones)}
                        </td>
                        {this.state.xmlFile && (
                          <td className="td-totales-right"></td>
                        )}
                      </tr>
                    </tbody>
                  ))}
                  <tbody>
                    <tr>
                      <th className="th-totales" style={{ width: "25%" }}>Total a pagar</th>
                      <td className="td-totales-right" style={{ width: "25%" }}></td>
                      <td className="td-totales-right" style={{ width: "25%" }}>
                        {dineroDisabledMask(total - cuentasProveedor)}
                      </td>
                      {this.state.xmlFile && (
                        <td className="td-totales-right" style={{ width: "25%" }}>
                          {dineroDisabledMask(this.state?.xmltotales?.Total)}
                        </td>
                      )}
                    </tr>
                  </tbody>
                </table>
                </>
              );
            }}
          </FormItem>
        </div>
      ),
    };
  }

  render() {
    const isMobile = window.innerWidth < 768;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Agregar Nota de Credito"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Space>
              {this.props.permisoAccesoLeerXml &&
                <Upload
                  showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
                  fileList={this.state.archivosXml}
                  customRequest={this.leerXml.bind(this)}
                  accept=".xml"
                >
                  <ButtonItem blanco type="primary" icon={<UploadOutlined />}>Leer Xml</ButtonItem>
                </Upload>
              }
              <ButtonItem cyan onClick={this.actualizarBoton.bind(this)}>Actualizar Informacion</ButtonItem>
            </Space>
          }
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarNotaDeCredito"
              layout
              onFinish={(values) => this.setState({ modalConfirmacion: true, valuesForm: values })}
              onFinishFailed={this.onFinishFailed}
            >
              <div style={{ padding: "0 16px", marginBottom: 16 }}>
                {this.renderProyectoCard()}
              </div>
              <GeneralFormLayout
                  totalesMaxWidth="50%" 
                cards={[
                  {
                    title: "Datos Generales",
                    lg: 24,
                    content: (
                      <Row>
                        <Col span={12} xs={24} sm={24} lg={12}>
                          <FormItem label="Proyecto" name="proyectoId" margin required>
                            <SelectItem placeholder="Proyecto">
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                        </Col>
                        <Col span={12} xs={24} sm={24} lg={12}>
                          <FormItem label="Proveedor" name="proveedorId" margin required>
                            <SelectItem placeholder="Proveedor" onChange={this.onChangeProveedor.bind(this)}>
                              {this.state.objetoProveedores}
                            </SelectItem>
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  
                  {
                    title: "Datos Factura",
                    lg: 18,
                    content: (
                      <Row>
                        <Col span={12} xs={24} sm={24} lg={12}>
                          <FormItem name="codigoFactura" label="Codigo Factura" margin pattern
                            labelCol={{ span: 10 }} wrapperCol={{ span: 13 }}
                          >
                            <InputItem placeholder="Codigo Factura" />
                          </FormItem>
                          <FormItem name="descripcion" label="Descripcion" margin pattern
                            labelCol={{ span: 10 }} wrapperCol={{ span: 13 }}
                          >
                            <InputItem placeholder="Descripcion" />
                          </FormItem>
                          <FormItem name="pagarFactura" initialValue={true} label="Pagar Facturas"
                            tooltip={{ title: "Pagar las facturas existentes con esta nota de credito" }}
                            margin pattern valuePropName="checked"
                            labelCol={{ span: 10 }} wrapperCol={{ span: 13 }}
                          >
                            <SwitchItem
                              onChange={(e) => {
                                if (!e) {
                                  const facturasRelacionadas = this.formRef.current.getFieldValue("facturasRelacionadas") || [];
                                  this.formRef.current.setFieldsValue({
                                    facturasRelacionadas: facturasRelacionadas.map((fr) => ({ ...fr, montoPago: undefined })),
                                  });
                                }
                              }}
                              placeholder="Pagar Facturas"
                            />
                          </FormItem>
                        </Col>
                        <Col span={12} xs={24} sm={24} lg={12}>
                          <FormItem name="uuid" label="UUID" margin pattern required
                            labelCol={{ span: 10 }} wrapperCol={{ span: 13 }}
                          >
                            <InputItem onChange={(e) => this.onChangeUUID(e.target.value)} placeholder="UUID" />
                          </FormItem>
                          <FormItem label="Fecha de N. C." name="fechaFactura" required margin
                            labelCol={{ span: 10 }} wrapperCol={{ span: 10 }}
                          >
                            <DatePickerItem placeholder="Fecha de N. C." allowClear={false} />
                          </FormItem>
                        </Col>
                      </Row>
                    ),
                  },
                  {
                    title: "Moneda",
                    lg: 6,
                    content: (
                      <>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.insumos?.length !== curr.insumos?.length}>
                          {({ getFieldValue }) => {
                            const insumos  = getFieldValue("insumos");
                            const disabled = insumos && insumos.length > 0;
                            return (
                              <FormItem required margin name="monedaId" label="Moneda"
                                labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}
                                initialValue="60c7e4396465ad440c41c15a"
                              >
                                <SelectItem disabled={disabled} onChange={(value) => {
                                  if (value === "60c7e4396465ad440c41c15a") {
                                    this.formRef.current.setFieldsValue({ tipoDeCambio: 1 });
                                  }
                                }} placeholder="Moneda">
                                  {this.state.objetoMonedas}
                                </SelectItem>
                              </FormItem>
                            );
                          }}
                        </FormItem>
                        <FormItem noStyle shouldUpdate={(prev, curr) => prev.monedaId !== curr.monedaId || prev.insumos?.length !== curr.insumos?.length}>
                          {({ getFieldValue }) => {
                            const monedaId = getFieldValue("monedaId");
                            const insumos  = getFieldValue("insumos");
                            const disabled = insumos && insumos.length > 0;
                            return monedaId !== "60c7e4396465ad440c41c15a" ? (
                              <FormItem required number margin label="T. Cambio" name="tipoDeCambio"
                                type="number" initialValue={1}
                                labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}
                              >
                                <InputNumberItem
                                  disabled={disabled}
                                  dinero placeholder="T. Cambio"
                                />
                              </FormItem>
                            ) : (
                              <FormItem name="tipoDeCambio" initialValue={1} hidden>
                                <InputNumberItem />
                              </FormItem>
                            );
                          }}
                        </FormItem>
                      </>
                    ),
                  },
                ]}
                tabsConfig={{
                  tabs: [
                    {
                      key: "insumos",
                      label: "Insumos",
                      listName: "insumos",
       
                      columns: this.getInsumosColumns(),
                      renderRow: this.renderInsumoRow.bind(this),
                      renderHeader: () => (
                        <Row justify="end" style={{ marginBottom: "0px", marginRight: "15px" }} gutter={8}>
                          <Col span={10}>
                            <Input.Search
                              prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                              placeholder="Buscar por descripción, código, clave o cód. barras..."
                              allowClear
                              enterButton={
                                <Button
                                  type="primary"
                                  style={{
                                    background: "#00BFD6",
                                    borderColor: "#00BFD6"
                                  }}
                                >
                                  Buscar
                                </Button>
                              }
                              size="middle"
                              onSearch={this.buscarInsumo}
                              onChange={(e) => {
                                if (!e.target.value) this.setState({ insumoResaltado: null });
                              }}
                              style={{ borderRadius: 8 }}
                            />
                          </Col>
                        </Row>
                      ),
                      renderFooter: ({ add, fields }) => (
                        <FormItem noStyle>
                          <ButtonItem
                            style={{
                              marginTop: 10,
                              marginBottom: 10,
                              justifySelf: fields.length > 0 ? "left" : null,
                              width: fields.length > 0 ? "auto" : null,
                            }}
                            type="primary"
                            onClick={() => add()}
                            block
                            cyan
                            icon={<PlusOutlined />}
                            hotkey="alt+a"
                          >
                            Agregar Insumo
                          </ButtonItem>
                        </FormItem>
                                        
                      ),
                    },
                    {
                      key: "facturas",
                      label: "Facturas",
                      listName: "facturasRelacionadas",
                      columns: this.getFacturasColumns(),
                      renderRow: this.renderFacturaRow.bind(this),
                      renderFooter: ({ add,  fields  }) => (
                        <FormItem noStyle>
                          <ButtonItem
                             style={{
                              marginTop: 10,
                              marginBottom: 10,
                              justifySelf: fields.length > 0 ? "left" : null,
                              width: fields.length > 0 ? "auto" : null,
                            }}
                            hotkey="alt+f"
                            type="primary"
                            onClick={() => {
                              const proveedorId = this.formRef.current.getFieldValue("proveedorId");
                              if (!proveedorId) {
                                message.error("Selecciona un proveedor primero");
                                return;
                              }
                              add({ tipoDeCambioCompra: 1 });
                            }}
                            block
                            cyan
                            icon={<PlusOutlined />}
                          >
                            Agregar Factura
                          </ButtonItem>
                        </FormItem>
                      ),
                    },
                  ],
                }}
                observacionesConfig={this.getObservacionesConfig()}
                isMobile={isMobile}
                actionButtons={
                  <ButtonItem type="primary" htmlType="submit" cyanB disabled={this.state.uuidDuplicado}>
                    Recibir
                  </ButtonItem>
                }
              />
            </Form>
          </Spin>
        </div>
        <ModalItem
          title="Confirmacion"
          visible={this.state.modalConfirmacion}
          onCancel={() => this.setState({ modalConfirmacion: false })}
          onOk={() => {
            this.setState({ modalConfirmacion: false });
            this.onFinish(this.state.valuesForm);
          }}
          spinning={false}
          footer
        >
          <h1 style={{ textAlign: "center" }}>Desea continuar</h1>
        </ModalItem>
        <ModalDiagnosticoCuadre
          visible={this.state.modalDiagnosticoVisible}
          diagnostico={this.state.diagnostico}
          onCancel={() => this.setState({ modalDiagnosticoVisible: false })}
          onAplicarAjuste={() => {
            this.setState({ modalDiagnosticoVisible: false });
            this.ajustarTotalesAutomaticamente(this.state.ajusteContexto);
          }}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permisoAccesoLeerXml:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "647a1df7bd6a695a9801702f"
      )?.activado,
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarNotaDeCredito);